import { VehicleV2 } from 'types/VehicleV2';
import ApiResponse from 'types/Apis/VehicleApiResponse';
import { ResponseRecord } from 'types/Apis/SearchResponse';
import { ContactInfo } from 'lib/LeadParams';
import FacebookPixel from 'lib/FacebookPixel';
import Geocode from 'types/Geocode';
import Criteo from 'lib/Criteo';
import Bing from 'lib/Bing';
import GoogleAdWords from 'lib/GoogleAdWords';
import GoogleAnalytics, { ECOMMERCE_REVENUE } from 'lib/GoogleAnalytics';
import { optimizelyTrack } from 'lib/OptimizelyClient';

interface TrackLeadSuccessParams {
  vehicle: VehicleV2 | ApiResponse | ResponseRecord;
  contactInfo: ContactInfo;
  zip: string | undefined;
  leadResponse: any;
  geolocation: Geocode | undefined;
  cplValue: number;
}

export function trackLeadSuccess({
  vehicle,
  contactInfo,
  zip,
  leadResponse,
  geolocation,
  cplValue,
}: TrackLeadSuccessParams): void {
  FacebookPixel.trackLeadSubmit(
    vehicle,
    contactInfo.zip,
    leadResponse.lead_id,
    zip || contactInfo.zip
  );
  Bing.convert();
  Criteo.trackLead(vehicle.vin, vehicle.price, leadResponse.lead_id);
  GoogleAdWords.trackConversion(vehicle.vin, cplValue, geolocation);
  GoogleAnalytics.ecommerce({
    id: leadResponse.lead_id,
    revenue: ECOMMERCE_REVENUE.lead,
    location: `listings/${vehicle.vin}`,
  });
  optimizelyTrack('Lead_Conversion');
}
